<template>
  <div>
    {{ ActDescBtn }}
    <v-container class="pa-0" fluid>
      <!-- Toolbar -->
      <v-row style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'aqui se registran los diferentes Tipos de Clientes'"
          :titulo="'Tipos de Clientes'"
          @MethodAnular="anular"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImportarDato="importarDato"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </v-row>
      <!-- fn Toolbar  -->
      <v-row>
        <!-- Barra de busqueda --->
        <v-col v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" cols="3">
          <div class="overflow-y-auto" v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <!-- <v-btn-toggle></v-btn-toggle> -->
                  <v-btn color="yellow accent-4" small width="95%" @click.prevent="actualiza_tb_ver">
                    <i class="fa fa-eye" style="font-size: 25px"></i>
                    ver
                  </v-btn>
                </center>
                <BarraDinamicaNormal
                  :ContListSlot="[
                    { Text: 'Código', NomValue: 'codigo', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Descripción', NomValue: 'descripcion', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Estado', NomValue: 'activo', Ctsl: 1, Type: 0.1, State: true },
                  ]"
                  :SeachNombre="'Búsqueda general'"
                  :emitnombre="'emitCXCTiposClientes'"
                  :headers="[
                    { text: 'Código', value: 'codigo' },
                    { text: 'Descripcion', value: 'descripcion' },
                  ]"
                  :nombre="'Tipos de Clientes'"
                  :url="$hostname + $hName + '/tipoclientes/findall'"
                />
              </template>
            </v-tooltip>
          </div>
        </v-col>
        <!-- fn Barra de busqueda --->

        <!-- Contenido central --->
        <v-col>
          <v-app id="inspire" class="overflow-y-auto">
            <!-- Formulario-Tipos de Clientes  -->

            <div class="px-2">
              <v-card color="grey lighten-3">
                <v-form ref="form" v-model="valid" class="pa-3 notranslate" lazy-validation @submit.prevent="" translate="no">
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="nuevoTiposClientes.descripcion"
                        :rules="[$rules.required]"
                        autocomplete="off"
                        dense
                        label="Descripcion"
                        outlined
                        required
                      >
                        <template v-slot:prepend>
                          <vue-fontawesome color="black" icon="edit" size="2"></vue-fontawesome>
                        </template>
                      </v-text-field>

                      <v-switch v-model="nuevoTiposClientes.activo" label="Activo"></v-switch>
                    </v-col>

                    <v-col>
                      <v-row>
                        <v-autocomplete
                          ref="subtipoSelectRef"
                          :items="subtiposList"
                          :search-input.sync="searchSubtipo"
                          clearable
                          dense
                          item-text="descripcion"
                          label="Subtipo"
                          no-filter
                          outlined
                          return-object
                          @change="addSubtipo"
                          @click:clear.prevent="clearSubtipos"
                          @focus.once="findAllSubtipos"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user-plus" style="font-size: 20px"></i>
                          </template>
                        </v-autocomplete>

                        <v-btn
                          :color="selectedSubtipo.id ? 'green' : 'blue'"
                          class="mx-2"
                          style="width: 1rem"
                          @click="showSubtipoDialog = !showSubtipoDialog"
                        >
                          <i
                            :class="selectedSubtipo.id ? 'fa fa-edit' : 'fa fa-plus'"
                            style="font-size: 20px; width: 20px; color: white"
                          ></i>
                        </v-btn>
                      </v-row>

                      <v-card v-if="nuevoTiposClientes.subtipos.length > 0" color="darken-1 grey">
                        <v-list>
                          <h3 class="text--lighten-2 pa-2">Subtipos asignados</h3>
                          <v-divider></v-divider>
                          <v-list-item v-for="(item, i) in nuevoTiposClientes.subtipos" :key="item.id" :value="item">
                            <p class="text-center my-auto">#{{ i + 1 }}</p>
                            <v-divider class="mx-2" vertical></v-divider>
                            <v-list-item-title v-text="item.descripcion"></v-list-item-title>
                            <v-list-item-action>
                              <v-btn rounded small @click="nuevoTiposClientes.subtipos.pop(i)">
                                <i class="fa fa-trash" style="font-size: 20px; color: red"></i>
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
                    <div class="pa-3"></div>
                  </v-row>
                </v-form>
              </v-card>
            </div>
            <!-- fn Formulario-Tipos de Clientes  -->
          </v-app>
        </v-col>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
      </v-row>
    </v-container>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data todo general -->
    <v-dialog
      v-model="acti_tb_data"
      fullscreen
      hide-overlay
      label="myAlert"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" dense flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>

          <v-spacer></v-spacer>

          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="[
                { text: 'Código', value: 'codigo', sortable: false, class: ['no-gutters black--text'] },
                { text: 'Descripcion', value: 'descripcion', sortable: false, class: ['no-gutters black--text'] },
              ]"
              :items="list"
              :search="search"
              dense
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn tb-data todo general -->

    <v-dialog v-model="showSubtipoDialog" width="50%">
      <v-card>
        <v-card-title class="primary darken-1 white--text">
          Formulario de Subtipo
          <v-spacer></v-spacer>
          <v-btn dark icon @click="showSubtipoDialog = false">
            <v-icon>fa fa-times</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="formSubtipo" class="pt-3">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-if="selectedSubtipo.id"
                  :value="selectedSubtipo.id"
                  dense
                  label="Codigo"
                  outlined
                  readonly
                >
                  <template v-slot:prepend>
                    <i class="fa fa-list-ol" style="font-size: 20px; width: 20px"></i>
                  </template>
                </v-text-field>
                <v-text-field
                  v-model="selectedSubtipo.descripcion"
                  :rules="[$rules.required]"
                  dense
                  label="Descripcion"
                  outlined
                >
                  <template v-slot:prepend>
                    <i class="fa fa-user-plus" style="font-size: 20px; width: 20px"></i>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="showSubtipoDialog = false">Cancelar</v-btn>
          <v-btn v-show="selectedSubtipo.id" color="error" @click="deleteSubtipo">Eliminar</v-btn>
          <v-btn :loading="isCreatingSubtipo" color="primary" @click="saveSubtipo">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--- Dialogo de confirmacion --->
    <DialogoConfirmacion ref="confirmDialog" />

    <!-- ------------------------------------------------------ Modal-notificacion general -->
    <v-dialog v-model="Elim_notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn small @click.prevent="eliminar(), (Elim_notif.estado = !Elim_notif.estado)">
            <i class="fa fa-check" style="font-size: 20px"></i>
            Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Modal-notificacion general -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- ------------------------------------------------------ Modal- Reporte Basico-->
    <v-dialog
      v-model="dialogimprimirList"
      label="Modal Reporte Basico"
      max-height="50%"
      max-width="80%"
      persistent
      transition="fab-transition"
    >
      <ModalReporteBasico :Datos="datosImprecion" @DataReporteBasico="DDataReporteBasico" />
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal Reporte Basico-->

    <!-- ------------------------------------------------------ Modal-Importar datos -->
    <v-dialog
      v-model="dialogImportarDatos"
      label="Modal Vale de caja"
      max-height="85%"
      max-width="95%"
      persistent
      transition="fab-transition"
    >
      <!--------------------- Creacion Vale de caja ------------------------------->
      <div>
        <v-toolbar color="indigo" dark dense>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-toolbar-title v-on="on">
                <i class="fa fa-info-circle" style="font-size: 20px"></i>
                Enviar Reporte
              </v-toolbar-title>
            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px">
              <span>Enviar Reporte:</span>
              Importar Tipos de Clientes
            </i>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle></v-btn-toggle>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="grey darken-4" fab small @click="cerrarImportarDatos">
                  <i class="fa fa-close" style="font-size: 20px; color: white"></i>
                </v-btn>
              </template>
              <span>CANCELAR: Retornar y no importar Datos</span>
            </v-tooltip>
          </v-card-actions>
        </v-toolbar>
        <v-card>
          <!-- columna Importar Datos -->
          <v-col cols="12" md="12" sm="12">
            <v-container>
              <v-card color="grey lighten-3">
                <b :class="`d-flex justify-center`">Importar Facturas</b>
                <v-form ref="formInputFile" v-model="valid" lazy-validation>
                  <!-- Row 1 Importar Datos     ------------------------------------------->

                  <v-row>
                    <v-col cols="12" md="12" sm="12">
                      <v-form ref="formInputFileTipoClient" v-model="valid" lazy-validation>
                        <v-file-input
                          id="excelTipoCliente"
                          v-model="ArchivotipoClient"
                          :rules="[$rules.required]"
                          accept=".csv,.xlsx, .xls ,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/xml "
                          counter
                          dense
                          label="Archivo de Tipos de clientes "
                          multiple
                          outlined
                          show-size
                          type="file"
                          @change=""
                        >
                          <template v-slot:append-outer>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn color="blue" dark fab x-small v-on="on" @click.prevent="SubirArchivoTipoCliente">
                                  <i class="fa fa-cloud-upload" style="font-size: 20px"></i>
                                </v-btn>
                              </template>
                              <span>Subir Archivo</span>
                            </v-tooltip>
                          </template>
                        </v-file-input>
                      </v-form>
                    </v-col>
                  </v-row>
                  <!-- Row 2 Importar Datos ------------------------------------------->
                </v-form>
              </v-card>
            </v-container>
          </v-col>
          <!-- columna informacion Importar Facturas -->
        </v-card>
      </div>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal-Importar datos -->

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "../../event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import BarraDinamicaNormal from "../../components/BarraDinamicaNormal"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteBasico from "../../components/ModalReporteBasico"
  import DialogoConfirmacion from "@/components/DialogoConfirmacion.vue"

  export default {
    components: {
      BarraBusqueda2,
      BarraDinamicaNormal,
      ContenidoBase,
      ModalReporteBasico,
      DialogoConfirmacion,
    },

    created() {
      var json = {
        titulo: "Tipos de Clientes",
        descripcion: "aqui se registran los diferentes Tipos de Clientes",
        save: true,
        eliminar: false,
        anular: false,
        nuevo: true,
        imprimir: true,
        accion: [
          "CXCTiposClientesNew",
          "CXCTiposClientesSave",
          "CXCTiposClientesRemove",
          "CXCTiposClientesAnular",
          "CXCTiposClientesPrintList",
        ],
      }
      EventBus.$emit("anularBotonesAccion", json)
    },

    mounted() {
      //EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      // EventBus.$on("CXCTiposClientesNew", this.new);
      // EventBus.$on("CXCTiposClientesSave", this.save);
      // EventBus.$on("CXCTiposClientesRemove", this.remove);
      // EventBus.$on("CXCTiposClientesAnular", this.remove);
      // EventBus.$on("CXCTiposClientesPrintList", this.imprimirList);
      EventBus.$on("emitCXCTiposClientes", this.datostabla)
      this.cargarTodo()
      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      dialogimprimirList: false,
      datosImprecion: {
        nombre: "TIPOS CLIENTES",
        UrlImprimir: "/tipoclientes/Imprimir",
        UrlExel: "/tipoclientes/Excel",
        UrlCorreo: "/tipoclientes/Correo",
        secuencia: 1,
        documento: 0,
      },

      dialogImportarDatos: false,
      ArchivotipoClient: null,

      ListaTiposClientes: [],
      windowSize: { width: "auto", height: "auto" },
      nuevoTiposClientes: {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        subtipos: [],
        usuarioCreacion: "Admin",
        usuarioModificacion: "",
        empresa: 1,
      },

      EstadoBtn: {
        BarraTablaDinamicaAprir: true,
        nuevo: true,
        guardar: true,
        eliminar: false,
        anular: false,
        imprimir: true,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: true,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      files: [],
      text: "",
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipos Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:",
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      formData: null,
      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?",
      },

      aalert: {
        estado: false,
        color: null,
      },

      showSubtipoDialog: false,
      formSubtipo: undefined,
      subtipo: "",
      searchSubtipo: "",
      isCreatingSubtipo: false,
      subtiposList: [],
      selectedSubtipo: {
        id: null,
        descripcion: "",
      },
    }),

    methods: {
      onResize(e) {
        this.windowSize = e
      },

      // Abriendo una panel donde mustra los datos en una tabla.
      abrirTabla() {
        this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir

        if (this.BarraTablaDinamicaAprir == true) {
          this.filtro()
        }
      },

      async cargarTodo() {
        await this.$axios
          .get(this.$hostname + this.$hName + "/tipoclientes/findall", { headers: this.$store.getters.GetheadersAxios })
          .then((res) => (this.ListaTiposClientes = res.data))
          .catch((error) => console.log(error))
      },

      // Un metodo que se llama cuando el usuario hace clic en una fila de la tabla.
      datostabla(e) {
        this.clearSubtipos()
        this.nuevoTiposClientes = e
        this.acti_tb_data = false
        this.$refs.subtipoSelectRef.reset()
      },

      // Envío de una solicitud POST al servidor.
      save() {
        if (this.$refs.form.validate()) {
          if (this.nuevoTiposClientes.codigo !== 0) {
            this.updateTipo()
          } else {
            this.$axios
              .post(this.$hostname + this.$hName + "/tipoclientes/salvar/", this.nuevoTiposClientes, {
                headers: this.$store.getters.GetheadersAxios,
              })
              .then((res) => {
                this.alerta("Dato guardado correctamente!", "bien")
              })
              .catch((error) => {
                console.log(error)
                let message = error.response.status === 409 ? error.response.data : "Error guardando el tipo"
                this.alerta(message, "error")
              })
          }
        } else {
          this.alerta("Los campos en rojo son requeridos", "error")
        }
      },

      updateTipo() {
        this.$axios
          .put(this.$hostname + this.$hName + "/tipoclientes/update", this.nuevoTiposClientes, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Dato actualizado correctamente!", "bien")
          })
          .catch((error) => {
            console.log(error)
            let message = error.response.status === 409 ? error.response.data : "Error actualizando el tipo"
            this.alerta(message, "error")
          })
      },

      remove() {
        if (this.nuevoTiposClientes.codigo != 0 && this.nuevoTiposClientes.codigo != null) {
          this.Elim_notif.estado = !this.Elim_notif.estado
        } else {
          this.alerta("Seleccione un tipos de cliente para eliminar", "error")
        }
      },

      eliminar() {
        var jsn = {
          datos: JSON.parse(JSON.stringify(this.nuevoTiposClientes)),
          usuario: JSON.parse(JSON.stringify(this.$user)),
        }

        if (this.nuevoTiposClientes.codigo != 0) {
          this.$axios
            .post(this.$hostname + this.$hName + "/tipoclientes/borrar/", this.nuevoTiposClientes, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              if (res.data <= 0) {
                this.alerta("El tipo de cliente que está intentando borrar lo está usando algún cliente", "error")
              } else {
                this.alerta("Dato eliminado correctamente!", "bien")
              }
            })
            .catch((error) =>
              this.alerta("El tipo de cliente que está intentando borrar lo está usando algún cliente", "error")
            )
        }
      },

      anular() {
        if (this.Elim_notif.estado) {
          var jsn = {
            datos: JSON.parse(JSON.stringify(this.nuevoTiposClientes)),
            usuario: JSON.parse(JSON.stringify(this.$user)),
          }
          this.$axios
            .post(this.$hostname + this.$hName + "/tipoclientes/borrar/", this.nuevoTiposClientes, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              this.alerta("Dato eliminado correctamente!", "bien")
            })
            .catch((error) => this.alerta("Dato no eliminado correctamente", "error"))
        }
      },

      // Activa un modal con la opcion de impresiones.
      imprimirList() {
        this.dialogimprimirList = true
      },

      DDataReporteBasico(e) {
        this.dialogimprimirList = e
      },

      // Creando un nuevo objeto y asignándolo a la variable nuevoTiposClientes.
      newwnuevo() {
        this.BarraTablaDinamicaAprir = false

        this.nuevoTiposClientes = {
          activo: true,
          borrado: false,
          codigo: 0,
          descripcion: "",
          descripcionOriginal: "",
          subtipos: [],
          fechaCreacion: "",
          fechaModificacion: "",
          usuarioCreacion: "",
          usuarioModificacion: "",
        }
        this.ArchivotipoClient = null
        this.formData = null
        this.subtipo = ""
        this.selectedSubtipo = { id: null, descripcion: "" }
        this.$refs.subtipoSelectRef.reset()
        this.cargarTodo()
        EventBus.$emit("actualizaBarraBusqueda2")
        EventBus.$emit("loading", false)
      },

      // Muestra un modal para importar datos.
      importarDato() {
        this.dialogImportarDatos = !this.dialogImportarDatos
      },

      // Cerrar el cuadro de diálogo dialogImportarDatos.
      cerrarImportarDatos() {
        this.dialogImportarDatos = false
      },

      // Subiendo un archivo al servidor.
      SubirArchivoTipoCliente() {
        if (this.$refs.formInputFileTipoClient.validate()) {
          EventBus.$emit("loading", true)
          var head = this.$store.getters.GetheadersAxios
          head["Content-Type"] = "multipart/form-data"
          head.usuario = this.$store.getters.GetdatosInfUsu.usuario.usuario
          this.formData = new FormData()
          this.formData.append("file", this.ArchivotipoClient[0])
          console.log(this.ArchivotipoClient)
          console.log(this.ArchivotipoClient[0])
          console.log(this.formData)
          this.$axios
            .post(this.$hostname + this.$hName + "/importData/tipoCliente", this.formData, { headers: head })
            .then((res) => {
              this.alerta("Dato importado correctamente", "bien")
              EventBus.$emit("loading", false)
            })
            .catch((error) => {
              this.alerta("Dato no importado correctamente", "error")
            })
        } else {
          this.alerta("Seleccione un archivo ", "error")
        }
      },

      alerta(e, l) {
        if (l == "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e
          this.newwnuevo()
        }

        if (l == "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e
          this.ejecucion = false
          EventBus.$emit("loading", false)
        }
      },
      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.filtro()
      },

      // Hacer una llamada API al backend y obtener los datos de la base de datos.
      async filtro() {
        await this.$axios
          .get(this.$hostname + this.$hName + "/tipoclientes/findall", { headers: this.$store.getters.GetheadersAxios })
          .then((res) => {
            this.list = res.data
          })
      },

      findAllSubtipos() {
        this.$axios
          .get(this.$hostname + this.$hName + "/tipoclientes/subtipos", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              descripcion: this.searchSubtipo,
            },
          })
          .then((res) => {
            this.subtiposList = res.data.content
          })
          .catch((error) => {
            console.error(error)
          })
      },

      clearSubtipos() {
        this.selectedSubtipo = {
          id: null,
          descripcion: "",
        }
      },

      saveSubtipo() {
        if (this.$refs.formSubtipo.validate()) {
          this.isCreatingSubtipo = true
          if (this.selectedSubtipo.id) {
            this.updateSubtipo()
          } else {
            this.$axios
              .post(this.$hostname + this.$hName + "/tipoclientes/subtipos", this.selectedSubtipo.descripcion, {
                headers: this.$store.getters.GetheadersAxios,
              })
              .then((res) => {
                this.showSubtipoDialog = false
                this.searchSubtipo = ""
              })
              .catch((error) => {
                console.error(error)
                this.alerta("Error guardando el subtipo", "error")
              })
          }
        }
        this.selectedSubtipo = { id: null, descripcion: "" }
        this.isCreatingSubtipo = false
      },

      updateSubtipo() {
        this.$axios
          .put(this.$hostname + this.$hName + "/tipoclientes/subtipos", this.selectedSubtipo, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.showSubtipoDialog = false
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error actualizando el subtipo", "error")
          })
        this.searchSubtipo = this.selectedSubtipo.descripcion
        this.nuevoTiposClientes.subtipos = this.nuevoTiposClientes.subtipos.map((item) =>
          item.id === this.selectedSubtipo.id ? { ...this.selectedSubtipo } : item
        )
      },

      async deleteSubtipo() {
        if (!this.selectedSubtipo || !this.selectedSubtipo.id) return
        if (!(await this.$refs.confirmDialog.show())) return
        let id = this.selectedSubtipo.id
        this.$axios
          .delete(this.$hostname + this.$hName + `/tipoclientes/subtipos/${id}`, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.showSubtipoDialog = false
            this.searchSubtipo = ""

            this.nuevoTiposClientes.subtipos = this.nuevoTiposClientes.subtipos.filter(
              (item) => item.id !== this.selectedSubtipo.id
            )

            this.clearSubtipos()
          })
          .catch((error) => {
            console.log(error)
            let message = error.response.status === 409 ? error.response.data : "Error borrando el subtipo"
            this.alerta(message, "error")
          })
      },

      addSubtipo(val) {
        this.selectedSubtipo = val ? { ...val } : { id: null, descripcion: "" }
        if (!val || this.nuevoTiposClientes.subtipos.some((subtipo) => subtipo.id === val.id)) return
        this.nuevoTiposClientes.subtipos.push(val)
      },
    },

    computed: {
      ActDescBtn() {
        if (this.nuevoTiposClientes.codigo > 0) {
          this.EstadoBtn = {
            BarraTablaDinamicaAprir: true,
            nuevo: true,
            guardar: true,
            eliminar: true,
            anular: false,
            imprimir: true,
            vercuenta: false,
            guardartemporal: false,
            restaurartemporal: false,
            importarDato: true,
            cargarProducto: false,
            ImprimirproductoInv: false,
          }
        }

        if (this.nuevoTiposClientes.codigo <= 0) {
          this.EstadoBtn = {
            BarraTablaDinamicaAprir: true,
            nuevo: true,
            guardar: true,
            eliminar: false,
            anular: false,
            imprimir: true,
            vercuenta: false,
            guardartemporal: false,
            restaurartemporal: false,
            importarDato: true,
            cargarProducto: false,
            ImprimirproductoInv: false,
          }
        }
      },
    },
    watch: {
      searchSubtipo() {
        this.findAllSubtipos()
      },
    },
  }
</script>
